/* eslint-disable max-statements, no-console */
import { htmlDecode, setUserSession, transformUser, userFragment } from "../services/eqqo.auth.service";
import { graphql } from "../../services/wp.api.service";

const query = `
	${userFragment}
	mutation LoginWithGoogle($token: String!) {
		loginWithGoogle(input: { token: $token }) {
			authToken
			refreshToken
			user {
				...UserFragment
			}
		}
	}
`;

const loginWithGoogle = (useMutation) => useMutation(
	["loginWithGoogle"],
	(variables) => graphql({
		query,
		variables,
	}).
		then((res) => {
			if (res.status === 200) {
				if (res.data?.data?.loginWithGoogle) {
					const { user, authToken, refreshToken } = res.data.data.loginWithGoogle;
					const [userRole] = user.roles.nodes;

					if (["administrator", "staff"].indexOf(userRole.name) >= 0 && window.location.host.search("localhost") === -1) {
						window.location.reload();
					} else {
						setUserSession(user, authToken, refreshToken);
						return transformUser(user);
					}
				} else {
					localStorage.removeItem("user");
					localStorage.removeItem("jwtAuthExpiration");

					if (res.data?.errors?.[0]) {
						throw new Error( htmlDecode( res.data.errors[0].message ) );
					}
					throw new Error("Bad login credentials.");
				}
				return null;
			}

			localStorage.removeItem("user");
			throw new Error("Please check your login credentials.");
		}).
		catch((error) => {
			console.log(error);
			localStorage.removeItem("user");
			localStorage.removeItem("jwtAuthExpiration");
			throw new Error(error || "Please check your login credentials.");
		})
);

export default loginWithGoogle;